export default {
  namespaced: true,
  state: {
    // The Work Experiences currently visible
    active: [],
    // Used to indicate when waiting on the server
    loading: false,
    // The search string being applied
    search: '',
    // What filters are currently applied
    filters: {},
    // The total records matching the filter according to the server (for pagination)
    total: 0,
    // The current page being viewed and its size
    page: 1,
    rowsPerPage: 25,
    // Sorting
    sort: {
      by: 'referredAt',
      descending: false,
    },
  },
  mutations: {
    setActive(
      state,
      {
        items = [],
        page = 1,
        per = 25,
        total = 0,
        search = null,
        sort = { by: 'id', descending: true },
        filters = {},
      }
    ) {
      state.search = search
      state.active = items
      state.sort = sort
      state.filters = filters
      state.page = page
      state.rowsPerPage = per
      state.total = total
      state.loading = false
    },
  },
  actions: {
    search(
      { commit, state },
      {
        search = '',
        page = 1,
        rowsPerPage = 25,
        sortBy = 'referred_at',
        descending = true,
        filters = {},
      }
    ) {
      this.$authorize('list', 'Referral')

      const params = {
        search: search,
        page: page,
        per: rowsPerPage,
        sort: `${sortBy} ${descending ? 'DESC' : 'ASC'}`,
        ...filters,
      }

      state.loading = true
      return Vue.$http
        .get('admin/referrals', { params })
        .then(response => commit('setActive', response.data))
        .catch(error => (state.loading = false))
    },
    create({ commit, dispatch }, referral) {
      this.$authorize('create', 'Referral')

      return Vue.$http.post('admin/referrals/',  referral).then(response => {
        commit('setActive', response.data)
        return response
      })
    },
  },
}
